import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import './CarDetails.css';
import { GiCarDoor } from "react-icons/gi";
import { IoPersonOutline } from "react-icons/io5";
import { GiCarSeat } from "react-icons/gi";
import { FaRoad } from "react-icons/fa";  
import { GiGearStickPattern } from "react-icons/gi";
import { MdDateRange } from "react-icons/md";
import { IoMdColorFill } from "react-icons/io";
import { IoSpeedometer } from "react-icons/io5";
import { PiEngineBold } from "react-icons/pi";
import { GiDustCloud } from "react-icons/gi";
import { GiHouseKeys } from "react-icons/gi";
import Slideshow from './CarSlideShow';

const CarDetailsAdmin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { car } = location.state || {}; // Get car details from state

 
  if (!car) {
    return <p>Car not found.</p>;
  }

  const MediaGallery = ({ videourl, images }) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  
    if (!Array.isArray(images) || images.length === 0) return null; // Return null if no images
  
    // Helper function to generate the appropriate video embed URL
    const getEmbedUrl = (url) => {
      if (url.includes("youtube.com") || url.includes("youtu.be")) {
        const videoId = url.split("v=")[1]?.split("&")[0] || url.split("/").pop();
        return `https://www.youtube.com/embed/${videoId}`;
      } else if (url.includes("vimeo.com")) {
        const videoId = url.split("/").pop();
        return `https://player.vimeo.com/video/${videoId}`;
      } else if (url.includes("drive.google.com")) {
        const videoId = url.split("/d/")[1]?.split("/")[0];
        return `https://drive.google.com/file/d/${videoId}/preview`;
      }
      return null;
    };
  
    // Navigate to the previous image
    const handlePrevClick = () => {
      setSelectedImageIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
    };
  
    // Navigate to the next image
    const handleNextClick = () => {
      setSelectedImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    };
  
    const videoEmbedUrl = videourl ? getEmbedUrl(videourl) : null;
  
    return (
      <div className="media-gallery">
        {videoEmbedUrl ? (
          <iframe
            src={videoEmbedUrl}
            title="Car Video"
            allowFullScreen
            className="video-frame"
          ></iframe>
        ) : (
          <div className="image-gallery">
            <div
              className="arrow left-arrow"
              onClick={handlePrevClick}
              style={{ left: "10px" }}
            >
              &#9664; {/* Left arrow character */}
            </div>
            <img
              src={images[selectedImageIndex]}
              alt="Car"
              className="main-image"
            />
            <div
              className="arrow right-arrow"
              onClick={handleNextClick}
              style={{ right: "10px" }}
            >
              &#9654; {/* Right arrow character */}
            </div>
            <div className="thumbnails-container">
              {images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Thumbnail ${index + 1}`}
                  className={`thumbnails ${
                    selectedImageIndex === index ? "active" : ""
                  }`}
                  onClick={() => setSelectedImageIndex(index)}
                  onMouseEnter={() => setSelectedImageIndex(index)}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  
  return (
    <>
      <div
        className="containerbefore"
        style={{
          backgroundImage: `url(${car.imagess[0]})`, // Use the first image from the 'images' array
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          objectFit:'cover',

          color: 'white', // Set text color to white for readability against the background
          borderRadius: '5px', // Optional: rounded corners
        }}
      >
        <h1  style={{ textShadow: '2px 2px 0px black, -2px -2px 0px black, 2px -2px 0px black, -2px 2px 0px black' }}>
          {car.manufacturer} {car.model} {car.variant}
        </h1>
      </div>

      <div className="car-details-container">
        <MediaGallery images={car.imagess}  videourl={car.videourl}/> {/* Include the image gallery */}
<h4>{car.attention}</h4>
        <div className='cariconsdetails'>
          
        <div className="icons-text-container">
            <div className="icons-text">
              <IoPersonOutline className="icons" />
              <div style={{display:'flex', flexDirection:'column'}}>
              <h5>Owner's</h5>
              <h4>{car.owner}</h4>
              </div>
              
            </div>
          </div>
          <div className="icons-text-container">
            <div className="icons-text">
              <MdDateRange className="icons" />
              <h4>{car.year}</h4>
            </div>
          </div>

          <div className="icons-text-container">
            <div className="icons-text">
              <IoSpeedometer className="icons" />
              <h4>{car.mileage}</h4>
            </div>
          </div>


          <div className="icons-text-container">
            <div className="icons-text">
              <PiEngineBold className="icons" />
              <h4>{car.capacity}L</h4>
            </div>
          </div>
          
          <div className="icons-text-container">
            <div className="icons-text">
              <GiGearStickPattern className="icons" />
              <h4>{car.transmission}</h4>
            </div>
          </div>

          <div className="icons-text-container">
            <div className="icons-text">
              <GiCarDoor className="icons" />
              <h4>{car.Doors}</h4>
            </div>
          </div>


          <div className="icons-text-container">
            <div className="icons-text">
              <GiCarSeat className="icons" />
              <h4>{car.seats}</h4>
            </div>
          </div>


          <div className="icons-text-container">
            <div className="icons-text">
              <GiHouseKeys className="icons" />
              <h4>{car.keys}</h4>
            </div>
          </div>
        </div>

        <div className='detailsformat'>
          <div className="details-section">
            <div className="details-section-part">
              <p><strong>Exterior Color:</strong>{car.exteriorColor}</p>
            </div>
            <div className="details-section-part">
              <p><strong>Interior Color:</strong>{car.interiorColor}</p>
            </div>
          </div>

          <div className="details-section">
            <div className="details-section-part">
              <p><strong>Ulez Exempt?</strong>{car.Ulez}</p>
            </div>
            <div className="details-section-part">
              <p><strong>Exterior Condition:</strong>{car.exteriorCondition}</p>
            </div>
          </div>
        </div>

        <div className="details-section" style={{ width: '100%' }}>
          <div className="details-section-part" style={{ width: '100%' }}>
            <p><strong>Description:</strong></p>
          </div>
          {car.description || 'No description available.'}
        </div>
        
      </div>
      
    </>
  );
};

export default CarDetailsAdmin;
